import styled from 'styled-components';

import { mediaQuery } from '../../globalStyles';
import { VisuallyHidden } from '../visually-hidden';

export const HiddenInput = VisuallyHidden.withComponent('input');

export const LabelWrapper = styled.div`
  display: flex;
`;

export const Label = styled.label<{ disabled?: boolean; checked?: boolean }>`
  background-color: ${(p) => p.theme.token('background-input')};
  border-color: ${(p) => p.theme.token('border-color-input')};
  border-radius: ${(p) => p.theme.token('border-radius-toggle-default')};
  border-style: solid;
  border-width: ${(p) => p.theme.token('border-width-input')};
  color: ${(p) => p.theme.token('text-default')};
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
  font: ${(p) => p.theme.token('text-style-form-input')};
  height: ${(p) => p.theme.token('height-input')};
  margin-right: -${(p) => p.theme.token('border-width-input')};
  padding: ${(p) => p.theme.token('padding-input')};

  display: flex;
  justify-content: center;
  align-items: center;

  position: relative;
  box-sizing: content-box;

  ${LabelWrapper}:first-of-type & {
    border-radius: ${(p) => p.theme.token('border-radius-toggle-start')};
  }

  ${LabelWrapper}:last-of-type & {
    border-radius: ${(p) => p.theme.token('border-radius-toggle-end')};
    margin-right: 0;
  }

  ${HiddenInput}:focus + & {
    background-color: ${(p) => p.theme.token('background-focus')};
    box-shadow: ${(p) => p.theme.token('box-shadow-button')};
    color: ${(p) => p.theme.token('text-default')};
    z-index: 200;
  }

  ${HiddenInput}:not(:focus-visible) + & {
    background-color: ${(p) => p.theme.token('background-input')};
    color: ${(p) => p.theme.token('text-default')};

    box-shadow: unset;
    z-index: unset;
  }

  ${HiddenInput}:focus-visible + & {
    background-color: ${(p) => p.theme.token('background-focus')};
    box-shadow: ${(p) => p.theme.token('box-shadow-button')};
    color: ${(p) => p.theme.token('text-default')};
    z-index: 200;
  }

  ${HiddenInput}:hover + & {
    border-color: ${(p) => p.theme.token('border-color-hover')};
    z-index: 100;
  }

  ${HiddenInput}:checked + & {
    background-color: ${(p) => p.theme.token('background-checked')};
    color: ${(p) => p.theme.token('text-reversed')};
    z-index: 200;
  }

  ${HiddenInput}[aria-invalid="true"] + & {
    border-color: ${(p) => p.theme.token('border-color-error')};
  }

  ${HiddenInput}[disabled] + & {
    background-color: ${(p) => p.theme.token('background-input')};
    border-color: ${(p) => p.theme.token('border-color-disabled')};
    color: ${(p) => p.theme.token('text-disabled')};
  }
`;

export const InputsWrapper = styled.div`
  display: flex;
`;

export const Wrapper = styled.div`
  @media ${mediaQuery.mobile} {
    width: 100%;

    ${InputsWrapper} {
      justify-content: stretch;
    }

    ${InputsWrapper},
    ${LabelWrapper},
    fieldset,
    label {
      width: inherit;
    }
  }
`;
